import { PrincipalIdSchema } from "@core/domains/identity";
import { identity } from "@core/foundation/function";
import { createModel, createModelSchemas } from "@core/foundation/model";
import { z } from "@core/zod";

export const GithubRepo = createModel({
  create: (item, schema) => {
    return { ...schema.decode(item) };
  },
  schemas: createModelSchemas({
    base: z.object(
      {
        fullName: z.string(),
        githubAccountId: z.int().nonnegative(),
        id: z.int().nonnegative(),
        lastReindexStartedAt: z.iso.datetime().nullable(),
        principalId: PrincipalIdSchema,
      },
      {
        fullName: "The repo's full name on GitHub, owner and name.",
        githubAccountId: "The id of the GitHub account the repo belongs to.",
        id: "The repo's GitHub id.",
        lastReindexStartedAt:
          "When the repo's last reindex started, or null before the first.",
        principalId: "The id of the principal the record belongs to.",
      },
    ),
    derive: {
      create: identity,
      recovery: identity,
      update: schema =>
        schema.pick({ fullName: true, lastReindexStartedAt: true }).partial(),
    },
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface GithubRepo extends z.infer<typeof GithubRepo.schema> {}
